<template>
  <v-app :style="{
    'background-image':
      !user && !screenLoader
        ? 'linear-gradient(180deg, rgb(35,35,35),rgb(20,20,20) 20%)'
        : 'linear-gradient(180deg, rgb(20,20,20),rgb(20,20,20) 20%)'
  }">
    <LoginDialog ref="LoginDialog" @login="login()"></LoginDialog>
    <Profile ref="Profile"></Profile>
    <TermsAndConditions ref="TermsAndConditions"></TermsAndConditions>
    <DonatorWarning ref="DonatorWarning"></DonatorWarning>

    <tap-target :show="showTutorial" :target="tapTargetFocus" size="50vh" backgroundColor="rgba(40,40,40,1)"
      color="#ffffff" contentLocation="ne" :title="targetTitle" :content="targetContent" @close="beginTutorial()" />

    <meta name="description" content="Quick and simple screen sharing for you and your friends!" />
    <confirm ref="confirm"></confirm>
    <alert ref="alert"></alert>
    <toast ref="toast"></toast>
    <toastVerify ref="toastVerify"></toastVerify>
    <friends :user="user" ref="friends"></friends>
    <v-app-bar v-if="!user && !screenLoader" app fixed flat hide-on-scroll dark color="rgba(0,0,0,0)"
      style="backdrop-filter: blur(4px)" :style="{
        'padding-left': $vuetify.breakpoint.smAndDown ? '2%' : '16%',
        'padding-right': $vuetify.breakpoint.smAndDown ? '2%' : '16%',
        'padding-top': $vuetify.breakpoint.smAndDown ? '6px' : ''
      }">
      <v-toolbar-title><img to="/" width="42px" height="42px" class="mt-3"
          :src="require('@/assets/logo.png')" /></v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn class="ml-3" small fab color="white" elevation="0" href="https://discord.com/invite/uMXKJRG" target="_blank">
        <img width="24px" :src="require('@/assets/discord.svg')">
      </v-btn>
      <v-btn class="ml-3" small fab color="white" elevation="0" @click="$refs.DonatorWarning.open()"
        href="https://www.patreon.com/join/trast?" target="_blank">
        <v-icon color="orange accent-4">mdi-patreon</v-icon>
      </v-btn>
      <v-btn class="ml-3" small fab color="white" elevation="0" href="https://twitter.com/trastlive" target="_blank">
        <v-icon color="blue">mdi-twitter</v-icon>
      </v-btn>

      <v-btn color="light-green accent-4" class="ml-4 font-weight-bold text-none text-h6" rounded large
        @click="$refs.LoginDialog.open(0)">
        Open Trast
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer app v-model="sidebarModel" ref="sidebar" v-if="user && sidebarToggled"
      :permanent="!$vuetify.breakpoint.smAndDown" :temporary="false" floating dark :mini-variant.sync="miniSidebar"
      @mouseleave.native="closeSidebar()" @mouseenter.native="openSidebar()" color="rgb(30,30,30)"
      class="blackScroll elevation-6" style="height: 100vh" id="sidebar" width="200">
      <template v-slot:prepend>
        <v-list-item two-line class="ma-2 pr-2 mb-0" :class="{ 'pl-0': miniSidebar }">
          <v-list-item-avatar class="mr-2">
            <img :src="require('@/assets/logo.png')" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title style="font-size: 20px"
              class="grey--text text--lighten-3 font-weight-light">Trast</v-list-item-title>
          </v-list-item-content>
          <!-- <v-icon color="grey" class="mr-3">mdi-information-outline</v-icon> -->
        </v-list-item>
      </template>

      <v-list class="mt-0 pt-0" style="height: 100%">
        <v-list-item class="" :class="{ 'pl-1': miniSidebar }">
          <v-btn dark :text="miniSidebar || $route.name == 'room'" block class="justify-start pl-3 text-none" to="/"
            exact><v-icon class="mr-4">mdi-home</v-icon>Home</v-btn>
        </v-list-item>
        <v-list-item class="mt-1" :class="{ 'pl-1': miniSidebar }">
          <v-btn dark block text class="justify-start pl-3 text-none" href="https://www.patreon.com/join/trast?"
            @click="$refs.DonatorWarning.open()" target="_blank"><v-icon class="mr-4"
              color="orange accent-4">mdi-patreon</v-icon>Subscribe</v-btn>
        </v-list-item>
        <v-list-item class="mt-1" :class="{ 'pl-1': miniSidebar }">
          <v-btn dark block text class="justify-start pl-3 text-none" href="https://discord.com/invite/uMXKJRG"
            target="_blank"><img width="24px" class="mr-4" :src="require('@/assets/discord.svg')">Join
            Discord</v-btn>
        </v-list-item>
        <v-list-item class="mt-1" :class="{ 'pl-1': miniSidebar }">
          <v-btn dark block text class="justify-start pl-3 text-none" href="https://twitter.com/trastlive"
            target="_blank"><v-icon class="mr-4" color="blue lighten-1">mdi-twitter</v-icon>Twitter</v-btn>
        </v-list-item>
        <v-slide-x-transition>
          <v-list-item class="mt-4" dense v-show="!miniSidebar">
            <p class="grey--text">Friends</p>
          </v-list-item>
        </v-slide-x-transition>
        <v-slide-x-transition>
          <v-list-item style="margin-top: -8px" v-show="!miniSidebar" ref="friendsInfo">
            <v-text-field v-model="friendInput" dense solo background-color="grey darken-3" placeholder="Search/add"
              prepend-inner-icon="mdi-magnify" append-icon="mdi-plus" :disabled="addFriendLoading"
              @click:append="addFriend()">
            </v-text-field>
          </v-list-item>
        </v-slide-x-transition>
        <v-slide-x-transition>
          <div style="
                                                margin-top: -12px;
                                                overflow-y: scroll;
                                                overflow-x: hidden;
                                                height: calc(100% - 297px);
                                              " id="sdfsdfsdf" v-show="!miniSidebar">
            <p v-if="!user.friends.length" class="text-center grey--text text--darken-1 ml-1 body-2">
              Your friends list is empty.
            </p>
            <p v-else-if="!filteredFriends.length && friendInput !== ''"
              class="text-center grey--text text--darken-1 ml-1 body-2">
              Search not found.
            </p>
            <template v-for="(friend, index) in filteredFriends">
              <v-hover v-slot:default="{ hover }" :key="index">
                <v-list-item style="margin-top: -8px" :key="index">
                  <v-avatar size="28" :color="!friend.avatar ? 'rgb(20,20,20)' : ''">
                    <v-img v-if="friend.avatar" :src="friend.avatar"></v-img>
                    <span v-else class="white--text text-subtitle-2 font-weight-light">{{ friend.username.substring(0, 2)
                    }}</span>
                  </v-avatar>

                  <v-slide-x-transition>
                    <v-btn color="white" class="float-right" style="
                                                          background-color: rgb(15, 15, 15);
                                                          position: absolute;
                                                          border: 15px solid rgb(15, 15, 15);
                                                        " small icon v-show="hover" @click="removeFriend(friend.id)">
                      <v-icon color="white" small>mdi-close</v-icon>
                    </v-btn>
                  </v-slide-x-transition>

                  <v-list-item-content>
                    <v-list-item-title class="grey--text text--lighten-3 ml-2">{{ friend.username }}</v-list-item-title>
                  </v-list-item-content>
                  <!-- <v-icon color="grey" class="mr-3">mdi-information-outline</v-icon> -->
                </v-list-item>
              </v-hover>
            </template>
          </div>
        </v-slide-x-transition>
      </v-list>

      <template v-slot:append>
        <div class="clickable" @click="$refs.Profile.open()" style="height: 70px" ref="userInfo" id="userInfo">
          <v-divider></v-divider>
          <v-list-item two-line :class="{ 'pl-2': miniSidebar }" style="margin-top: 2px">
            <v-avatar color="rgb(20,20,20)" class="mr-3 pl-0 ml-0" size="40px">
              <img v-if="user.avatar" :src="user.avatar" />
              <span v-else class="white--text text-h6 font-weight-light">{{
                user.username.substring(0, 2)
              }}</span>
            </v-avatar>

            <v-slide-x-transition>
              <v-list-item-content v-show="!miniSidebar">
                <v-list-item-title>{{ user.username }}</v-list-item-title>
                <v-list-item-subtitle>Logged In</v-list-item-subtitle>
              </v-list-item-content>
            </v-slide-x-transition>
          </v-list-item>
          <!-- <div class="pa-2">
          <v-btn block color="red accent-4" @click="logout()">
            Logout
          </v-btn>
        </div> -->
        </div>
      </template>
    </v-navigation-drawer>

    <v-progress-circular v-if="screenLoader" style="
                                          z-index: 400;
                                          position: fixed;
                                          left: calc(50% - 32px);
                                          top: calc(50% - 32px);
                                        " size="64" indeterminate color="light-green accent-4"></v-progress-circular>

    <v-main>
      <router-view v-if="!screenLoader" @login="login()" @roomID="roomID = $event" @streaming="streaming = $event"
        @host="host = $event" @users="users = $event" @roomCover="roomCover = $event"
        @theatreMode="theatreMode = $event"></router-view>
    </v-main>
  </v-app>
</template>

<style>
/* width */
.whiteScroll *::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

/* Track */
.whiteScroll * ::-webkit-scrollbar-track {
  background: rgb(230, 230, 230) !important;
}

/* Handle */
.whiteScroll * ::-webkit-scrollbar-thumb {
  background: rgb(190, 190, 190) !important;
  border-radius: 40px !important;
}

/* Handle on hover */
.whiteScroll * ::-webkit-scrollbar-thumb:hover {
  background: rgb(170, 170, 170) !important;
}

/* width */
.blackScroll *::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

/* Track */
.blackScroll * ::-webkit-scrollbar-track {
  background: rgb(30, 30, 30) !important;
}

/* Handle */
.blackScroll * ::-webkit-scrollbar-thumb {
  background: rgb(20, 20, 20) !important;
  border-radius: 40px !important;
}

/* Handle on hover */
.blackScroll * ::-webkit-scrollbar-thumb:hover {
  background: rgb(18, 18, 18) !important;
}

.tap-target {
  font-family: "Roboto";
}

.v-btn--router {
  background-color: initial !important;
  color: initial !important;
}

.v-btn--router .v-btn__content {
  color: white !important;
}

.v-btn--active {
  background-color: rgb(25, 25, 25) !important;
  color: rgb(25, 25, 25) !important;
}

.v-btn--active .v-btn__content {
  color: white !important;
}

.centered {
  margin-left: auto !important;
  margin-right: auto !important;
}

.row {
  max-width: initial !important;
}

.clickable {
  cursor: pointer !important;
}

.notClickable {
  cursor: default !important;
}

.active:before {
  background-color: #999999 !important;
}

#sidebar * {
  transition: 0.15s padding ease-out;
}

html,
body {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
</style>
<script>
import Confirm from "@/components/confirm.vue";
import Alert from "@/components/alert.vue";
import Toast from "@/components/toast.vue";
import ToastVerify from "@/components/toastVerify.vue";
import Friends from "@/components/friends.vue";
import LoginDialog from "@/components/LoginDialog.vue";
import Profile from "@/components/Profile.vue";
import TermsAndConditions from "@/components/TermsAndConditions.vue";
import DonatorWarning from "@/components/DonatorWarning.vue";


export default {
  name: "App",
  components: {
    Confirm,
    Alert,
    Toast,
    ToastVerify,
    Friends,
    LoginDialog,
    Profile,
    TermsAndConditions,
    DonatorWarning
  },
  data: () => ({
    drawer: false,
    roomID: null,
    flat: true,
    roomOwner: {},
    streaming: false,
    host: false,
    users: [],
    roomCover: null,
    theatreMode: false,
    screenLoader: true,
    miniSidebar: false,
    friendInput: "",
    addFriendLoading: false,
    sidebarModel: false,
    show: false,
    showTutorial: false,
    tapTargetFocus: null,
    targetTitle: "",
    targetContent: "",
    targetStage: 0
  }),
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
    this.$root.$alert = this.$refs.alert.open;
    this.$root.$toast = this.$refs.toast.open;
    this.$root.$TermsAndConditions = this.$refs.TermsAndConditions;
    this.$root.$DonatorWarning = this.$refs.DonatorWarning;
    this.$root.$toastClose = this.$refs.toast.close;
    this.$root.$toastVerify = this.$refs.toastVerify;
    this.$root.logout = this.logout;
    this.$root.setSidebar = this.setSidebar;
    this.$root.targetStage = this.getTargetStage;

    this.init();
  },
  watch: {
    $route(to) {
      if (to.name == "room" && !this.$vuetify.breakpoint.smAndDown) {
        this.miniSidebar = true;
      } else {
        this.miniSidebar = false;
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    sidebarToggled: {
      get: function () {
        return this.$store.state.sidebarToggled;
      },
      set: function () { }
    },
    filteredFriends() {
      let initial = this.user.friends.filter(({ username }) =>
        username.includes(this.friendInput)
      );
      let second = this.user.friends.filter(({ username }) =>
        username.toLowerCase().includes(this.friendInput.toLowerCase())
      );
      let ids = initial.map(user => {
        return user.id;
      });

      let result = initial.concat(second.filter(({ id }) => !ids.includes(id)));

      return result;
    }
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    getTargetStage() {
      return this.targetStage;
    },
    beginTutorial() {
      if (this.targetStage == 0) {
        this.tapTargetFocus = this.$refs.sidebar;
        this.targetTitle = "This is your friends list";
        this.targetContent =
          "Here you can add and remove friends, only they can join your private rooms.";
        this.showTutorial = true;
      }

      if (this.targetStage == 1) {
        this.tapTargetFocus = this.$refs.userInfo;
        this.targetTitle = "This is your account info";
        this.targetContent = "Click to log out, change your avatar and more!";
        this.showTutorial = true;
      }

      if (this.targetStage == 2) {
        this.showTutorial = false;
        this.$router.push("/" + this.user.username);
      }
      this.targetStage++;
    },
    setSidebar(value) {
      this.sidebarModel = value;
    },
    init() {
      this.login();

      if (this.$route.name == "room" && !this.$vuetify.breakpoint.smAndDown) {
        this.miniSidebar = true;
      } else {
        this.miniSidebar = false;
      }
    },
    login() {
      let token = localStorage.getItem("token");

      this.screenLoader = true;
      this.$store.commit("setScreenLoader", this.screenLoader);

      if (token) {
        this.screenLoader = true;
        this.$socket.emit("get user", token, user => {
          if (user) {
            this.$store.commit("setUser", user);
            this.loggedIn();
          } else {
            this.$store.commit("setUser", null);
            localStorage.removeItem("token");
            this.$root.$toast(
              "Your login session has expired. Please sign in again."
            );
            this.couldntLogIn();
          }
          this.screenLoader = false;
          this.$store.commit("setScreenLoader", this.screenLoader);
        });
      } else {
        this.screenLoader = false;
        this.$store.commit("setScreenLoader", this.screenLoader);
        this.couldntLogIn();
      }
    },
    logout() {
      this.$store.commit("setUser", null);
      localStorage.removeItem("token");
      if (this.$route.name !== "home") this.$router.replace("/");
      this.$root.$toastVerify.close();
    },
    changeName() {
      this.$refs.RoomChange.open().then(neww => {
        this.$socket.emit("change room name", {
          newName: neww,
          roomID: this.roomID
        });
      });
    },
    loggedIn() {
      if (
        this.$route.name == "home" &&
        localStorage.getItem("hereBefore") === null && !this.isMobile()
      ) {
        this.$root
          .$confirm("Welcome to Trast!", "Would you like a quick tutorial?", {})
          .then(confirm => {
            localStorage.setItem("hereBefore", true);
            if (confirm) {
              this.$nextTick(() => {
                if (this.tapTargetFocus == null) {
                  this.beginTutorial();
                }
              });
            }
          });
      }

      this.$root.$toastClose();
      if ("v" in this.$route.query) {
        if (!this.user.email.verified) {
          let param = this.$route.query.v;
          this.$socket.emit(
            "verify email",
            {
              userID: this.user.id,
              validate: param
            },
            valid => {
              if (valid) {
                this.$root.$alert(
                  "Success",
                  "Successfully verified email address."
                );
                this.user.email.verified = true;
                this.$store.commit("setUser", this.user);
                this.$root.$toastVerify.close();
              } else {
                this.$root.$alert("Error", "Failed to verify email address!", {
                  color: "red accent-4"
                });
                this.user.email.verified = false;
                this.$store.commit("setUser", this.user);
              }
            }
          );
        } else {
          this.$root.$alert(
            "Error",
            "Your email address is already verified!",
            {
              color: "red accent-4"
            }
          );
        }
        if (this.$route.name !== "home") this.$router.replace("/");
      } else if ("r" in this.$route.query) {
        if (this.$route.name !== "home") this.$router.replace("/");
      }

      if (!this.user.email.verified) {
        this.$root.$toastVerify.open();
      }
    },
    couldntLogIn() {
      if (this.$route.name !== "home") this.$router.replace("/");
      if ("r" in this.$route.query) {
        this.$refs.LoginDialog.open(1);
      }
    },
    openSidebar() {
      if (this.$route.name == "home") return;
      this.miniSidebar = false;
    },
    closeSidebar() {
      if (this.$route.name == "home") return;
      this.miniSidebar = true;
    },
    addFriend() {
      if (this.friendInput.length) {
        let object = {
          userID: this.user.id,
          friendInput: this.friendInput,
          token: this.user.token
        };
        this.addFriendLoading = true;
        this.$socket.emit("add friend", object, response => {
          this.addFriendLoading = false;
          this.friendInput = "";

          if (response) {
            if (response.error) {
              if (response.error == "invalid token") {
                this.$root.logout();
                this.$root.$alert("Error", "Your login session has expired.", {
                  color: "red accent-4"
                });
              } else if (response.error == "invalid username") {
                this.$root.$alert("Error", "That username is invalid.", {
                  color: "red accent-4"
                });
              } else if (response.error == "unknown") {
                this.$root.$alert("Error", "An unknown error has occured.", {
                  color: "red accent-4"
                });
              } else if (response.error == "not found") {
                this.$root.$alert(
                  "Error",
                  `User <b>${object.friendInput}</b> was not found.`,
                  {
                    color: "red accent-4"
                  }
                );
              } else if (response.error == "add self") {
                this.$root.$alert("Error", "You cannot add yourself.", {
                  color: "red accent-4"
                });
              } else if (response.error == "already added") {
                this.$root.$alert(
                  "Error",
                  `<b>${object.friendInput}</b> is already your friend.`,
                  {
                    color: "red accent-4"
                  }
                );
              }
            } else if (response.success) {
              this.user.friends = response.success;
              this.$store.commit("setUser", this.user);
              this.$root.$alert("Success", "Successfully added friend.");
            }
          }
        });
      }
    },
    removeFriend(friendID) {
      let object = {
        userID: this.user.id,
        friendID: friendID,
        token: this.user.token
      };
      this.$socket.emit("remove friend", object, response => {
        if (response) {
          if (response.error) {
            if (response.error == "invalid token") {
              this.$root.logout();
              this.$root.$alert("Error", "Your login session has expired.", {
                color: "red accent-4"
              });
            } else if (response.error == "unknown") {
              this.$root.$alert("Error", "An unknown error has occured.", {
                color: "red accent-4"
              });
            }
          } else if (response.success) {
            this.user.friends = response.success;
            this.$store.commit("setUser", this.user);
            this.$root.$alert("Success", "Successfully removed friend.");
          }
        }
      });
    }
  }
};
</script>
